module.exports = __webpack_public_path__ + "static/services-it-talent-0c64666419156520a4ee3c0973cbbc6f.svg";